module.exports = require("-!babel?optional[]=runtime!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./checkboxGroup.vue")
module.exports.template = require("-!vue-html!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./checkboxGroup.vue")



/*****************
 ** WEBPACK FOOTER
 ** ./src/checkboxGroup.vue
 ** module id = 92
 ** module chunks = 0
 **/